var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-music"},[_c('div',{staticClass:"musicBox",class:_vm.toShow ? '' : 'hideStyle',on:{"click":_vm.playBtn}},[_c('img',{class:_vm.isPlay ? 'turnRotate' : '',attrs:{"src":require("../../assets/player.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }